import React from "react";
import AboutSection from "../components/HomePage/AboutSection";
import HerroSection from "../components/HomePage/HerroSection";
import SectionProjectsList from "../components/HomePage/SectionProjectsList";
import CompanyViewSection from "../components/HomePage/CompanyViewSection";
import NewsSection from "../components/HomePage/NewsSection";

const Home = () => {
  return (
    <div className="relative ">
      <HerroSection />
      <AboutSection />
      <CompanyViewSection />
      <SectionProjectsList />

      <NewsSection />
    </div>
  );
};

export default Home;
